// Alliant Program Variables
export const alliantVariables: any = {
    programTitle: "Alliant Insurance Services, Inc.",
    effectiveDates: "11/15/2026 - 11/15/2027",
    feeDisclaimer: "All Premiums are subject to 3% California Surplus Lines Tax and 0.18% Stamping Fee (not included in below premiums).",
    EL_Items: [
        "Alliant_EL_Header",
        ["Alliant_EL_1M", "$1,000,000", "$1,181.00"],
        ["Alliant_EL_2M", "$2,000,000", "$1,632.00"],
        ["Alliant_EL_3M", "$3,000,000", "$1,914.00"],
        ["Alliant_EL_5M", "$5,000,000", "$2,380.00"],
        ["Alliant_EL_10M", "$10,000,000*", "$3,878.00"],
        ["Alliant_EL_15M", "$15,000,000**", "$7,788.00"],
        ["Alliant_EL_20M", "$20,000,000**", "$11,011.00"],
        ["Alliant_EL_25M", "$25,000,000**", "$14,621.00"],
        ["Alliant_EL_30M", "$30,000,000**", "$18,226.00"],
        ["Alliant_EL_40M", "$40,000,000**", "$28,674.00"]
    ],
    EL_Disclaimers: [
        "<strong>*</strong>The maximum limit of liability for any participants without their underlying home and auto insurance policies in place with Chubb.",
        "<strong>**</strong>It is a requirement that any participant who <u>newly elects or enrolls</u> at these limits have their underlying home and auto insurance policies in place with Chubb and complete the Group Personal Excess Participants Questionnaire. These limits are subject to prior underwriting approval. <em>These requirements have been waived for current participants renewing at their expiring limit</em>."
    ],
    UM_Label: "Please select your desired coverage limits for each section below.",
    UM_Items: [
        "Alliant_UM_Header",
        ["Alliant_UM_1M", "$1,000,000", "Included above"],
        ["Alliant_UM_2M", "$2,000,000", "$185.00"],
        ["Alliant_UM_3M", "$3,000,000", "$432.00"],
        ["Alliant_UM_5M", "$5,000,000", "$996.00"],
        ["Alliant_UM_10M", "$10,000,000", "$2,283.00"]
    ],
    UM_Disclaimers: ["<strong>*</strong>The UM/UIM limit cannot be higher than the liability limit."],
    EPLI_Items: [
        "Alliant_EP_Header",
        ["Alliant_EP_Decline", "By selecting this box, I am declining EPLI Insurance."],
        ["Alliant_EP_250K", "$250,000 per occurrence / $500,000 aggregate*", "$10,000", "$1,301.00"],
        ["Alliant_EP_500K", "$500,000 per occurrence / $500,000 aggregate*", "$10,000", "$1,950.00"]
    ],
    EPLI_Disclaimer: "<strong>*</strong>Any participant who newly elects this coverage is required to complete the Chubb Employment Practice Liability Coverage Request Worksheet.",
    CI_Items: [
        "Alliant_CI_Header",
        "Alliant_CI_Yes",
        "Alliant_CI_No"
    ],
    learnMoreUrl: "../../../assets/umbrella/Complimentary-Personal-Insurance-Review-Alliant-Private-Client-pgs.pdf"
};
